import type { ErrorType } from '~/data/ErrorRecord';

export const defaultState: Fields = {
  isModalOpen: false,
  hasError: false,
  machineId: '',
  machineName: '',
  error: undefined,
};

export interface Fields {
  isModalOpen: boolean;
  hasError: boolean;
  machineId: string;
  machineName: string;
  error?: ErrorType;
}
